import type { IDiaryValidated } from '@common/validation/holterDiary';
import { fetchJson } from '@frontend/store/fetch';

export async function createHolterDiaryForProcedure(requestId: string, body: IDiaryValidated): Promise<void> {
    await fetchJson({
        body,
        method: 'POST',
        url: `/api/procedures/${requestId}/holterDiary`,
    });
}
